












































import { Component, Emit, Prop, Vue } from 'vue-property-decorator';
import { EntityLocation } from '@/api';
import Toast from '@/components/display/toast.vue';
import { Validation, validationMixin } from 'vuelidate';
import { mixins } from 'vue-class-component';
import { Validations } from 'vuelidate-property-decorators';
import { required } from 'vuelidate/lib/validators';

@Component({})
export default class LocationInput extends Vue {
	@Prop({ required: true, type: Object })
	private existingLocation!: EntityLocation;

	@Prop({ required: true, type: Object })
	private validation!: Validation;

	public location: EntityLocation = this.existingLocation;
	public settingLocation: boolean = false;

	private created() {
		this.validation.$touch();
	}

	@Emit('locationChanged')
	private onLocationChanged(): EntityLocation {
		this.validation.$touch();
		return this.location;
	}

	public setFromCurrentLocation(): void {
		this.settingLocation = true;
		navigator.geolocation.getCurrentPosition(
			(position: Position) => {
				this.location.latitude = +position.coords.latitude ?? 0;
				this.location.longitude = +position.coords.longitude ?? 0;
				this.onLocationChanged();
				this.settingLocation = false;
			},
			err => {
				new Toast().makeToast(
					`Failed to get your current location: ${err.message ?? 'Unknown error'}`,
					'Geo - Location Error',
					'danger',
					true,
				);
				this.settingLocation = false;
			},
		);
	}

	public isValid(field: any) {
		return field && field.$dirty ? !field.$invalid : null;
	}
}
